var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info main_center" },
    [
      _c("div", { staticClass: "top-content busWinessLeft" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticStyle: { width: "100%", height: "68px" } }),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.detail.title))]),
        _c("br"),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.detail.content) } }),
      ]),
      _vm.detail.fileList.length
        ? _c(
            "el-row",
            { staticClass: "content" },
            _vm._l(_vm.detail.fileList, function (item, index) {
              return _c(
                "el-col",
                { key: index, attrs: { span: 24 } },
                [
                  _c(
                    "el-form",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: item.fileTypeName
                              ? item.fileTypeName + "："
                              : "附件：",
                            prop: "attachments" + item.fileType,
                            size: "small",
                          },
                        },
                        [
                          _c("affix-msg", {
                            attrs: {
                              showDetail: true,
                              docItem: item,
                              docName: item.name,
                            },
                            on: {
                              "update:docItem": function ($event) {
                                item = $event
                              },
                              "update:doc-item": function ($event) {
                                item = $event
                              },
                              "update:docName": function ($event) {
                                return _vm.$set(item, "name", $event)
                              },
                              "update:doc-name": function ($event) {
                                return _vm.$set(item, "name", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }